import React, {useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import isURL from 'validator/lib/isURL';

const useStyles = makeStyles((theme) => ({

})); 


const EditTrainingDialog = ({isDialogOpen, setIsDialogOpen, editTraining, setEditTraining, saveCallback, autoCompletes}) => {
    const classes = useStyles();
    
    const [training, setTraining] = useState({title:"", type: "", subject: "", network: "", institution: "", duration:0, ecpoints:0, start:"", contact: "", link:"", cost: "", note: ""});
    const [errMsg, setErrMsg] = useState('');

    const validateURL = (e) => {

        setTraining({ ...training, link: e.target.value })

        if (isURL(training.link)) {
           setErrMsg("");
        } else {
           setErrMsg('ungültige URL');
        }
    };


    useEffect(() => {
        setTraining({ ...editTraining});
    }, [editTraining]);

    return (    
    <Dialog
        open={ isDialogOpen }
        onClose={() => {setIsDialogOpen(false)}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
        {"Weiterbildung hinzufügen"}
        </DialogTitle>
        <DialogContent>
            <TextField
                id="training-title"
                label="Titel"
                placeholder="Titel"
                margin="normal"
                variant="outlined"
                required={true}
                fullWidth={true}
                autoFocus
                value={training.title}
                onChange={(e)=> setTraining({ ...training, title: e.target.value })}
                multiline
                rows={4}
            />
            <TextField
                id="training-type"
                label="Typ"
                placeholder="Typ"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                autoFocus
                value={training.type}
                onChange={(e)=> setTraining({ ...training, type: e.target.value })}
                multiline
            />
            <Autocomplete
                disablePortal
                freeSolo
                id="training-subject"
                renderInput={(params) => <TextField {...params} label="Thema" />}
                placeholder="Thema"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                value={training.subject}
                onInputChange={(e,newValue)=> { 
                    //console.log(newValue)
                    setTraining({ ...training, subject: newValue })}
                }
                options={autoCompletes.subjects}
            />
            <TextField
                id="training-network"
                label="Verbund"
                placeholder="Verbund"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                autoFocus
                value={training.network}
                onChange={(e)=> setTraining({ ...training, network: e.target.value })}
                multiline
            />
            <Autocomplete
                disablePortal
                freeSolo
                id="training-institution"
                renderInput={(params) => <TextField {...params} label="Institution" />}
                placeholder="Institution"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                value={training.institution}
                onInputChange={(e,newValue)=> setTraining({ ...training, institution: newValue })}
                options={autoCompletes.institutions}
            />
            <TextField
                id="training-duration"
                label="Dauer in Semester (nur Zahl eingeben)"
                placeholder="Dauer in Semester (nur Zahl eingeben)"
                margin="normal"
                variant="outlined"
                required={true}
                fullWidth={true}
                autoFocus
                value={training.duration}
                onChange={(e)=> setTraining({ ...training, duration: e.target.value })}
                type="number"
            />
            <TextField
                id="training-ecpoints"
                label="Umfang in EC Punkten (nur Zahl eingeben)"
                placeholder="Umfang in EC Punkten (nur Zahl eingeben)"
                margin="normal"
                variant="outlined"
                required={true}
                fullWidth={true}
                type="number"
                autoFocus
                value={training.ecpoints}
                onChange={(e)=> setTraining({ ...training, ecpoints: e.target.value })}
            />
            <TextField
                id="training-start"
                label="Beginn"
                placeholder="Beginn"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                autoFocus
                value={training.start}
                onChange={(e)=> setTraining({ ...training, start: e.target.value })}
                multiline
            />
            <TextField
                id="training-contact"
                label="Kontakt"
                placeholder="Kontakt"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                autoFocus
                value={training.contact}
                onChange={(e)=> setTraining({ ...training, contact: e.target.value })}
                multiline
            />
            <TextField
                error={errMsg ? true : false}
                helperText={errMsg}
                id="training-link"
                label="Link"
                placeholder="Link"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                autoFocus
                value={training.link}
                onChange={validateURL }
                multiline
            />
            <TextField
                id="training-cost"
                label="Kosten"
                placeholder="Kosten"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                autoFocus
                value={training.cost}
                onChange={(e)=> setTraining({ ...training, cost: e.target.value })}
                multiline
            />
            <TextField
                id="training-note"
                label="Anmerkung"
                placeholder="Anmerkung"
                margin="normal"
                variant="outlined"
                fullWidth={true}
                autoFocus
                value={training.note}
                onChange={(e)=> setTraining({ ...training, note: e.target.value })}
                multiline
            />
        </DialogContent>
        <DialogActions>
            <Button 
                onClick={() => { 
                    setIsDialogOpen(false);
                    setTraining({ title:"", type: "", subject: "", network: "", institution: "", duration:0, ecpoints:0, start:"", contact: "", link:"", cost: "", note: ""});
                    }
                }
            >
                abbrechen
            </Button>
            <Button 
                variant='contained'
                onClick={() => { 
                    setIsDialogOpen(false);
                    saveCallback(training);
                    setEditTraining({title:"", type: "", subject: "", network: "", institution: "", duration:0, ecpoints:0, start:"", contact: "", link:"", cost: "", note: ""});
                    }
                }
                disabled={ !training.title }
            >
                speichern
            </Button>
        </DialogActions>
    </Dialog>
    );
}

export default EditTrainingDialog;